<div [formGroup]="parentForm">
    <ngx-recaptcha2
        #recaptchaElement
        [siteKey]="siteKey"
        [useGlobalDomain]="useGlobalDomain"
        [size]="size"
        [hl]="[language]"
        [theme]="theme"
        [type]="type"
        [formControlName]="controlName"
        (load)="onLoaded()"
        (reset)="onResetted()"
        (expire)="onExpired()"
        (success)="onSucceeded()">
    </ngx-recaptcha2>
</div>
